// @flow

import type {PureAction} from '@travel-frontend/state-handling-sdk';
import type {TypeOfPayment} from 'redux/v1/paymentTravel/models';

import {PURE} from '@travel-frontend/state-handling-sdk';

export const SET_SELECTED = 'uiState/payment/SET_SELECTED';
export const SET_INSURANCE_SELECTED = 'uiState/payment/SET_INSURANCE_SELECTED';
export const SET_CC_TYPE = 'uiState/payment/SET_CC_TYPE';
export const SET_CC_TYPEERROR = 'uiState/payment/SET_CC_TYPEERROR';
export const SET_CC_CHALLENGE = 'uiState/payment/SET_CC_CHALLENGE';
export const SET_CC_IFRAMEHEIGHT = 'uiState/payment/SET_CC_IFRAMEHEIGHT';
export const SET_FAILED_AUTH_ATTEMPTS =
  'uiState/payment/SET_FAILED_AUTH_ATTEMPTS';
export const SET_PSDLAYER_TYPE = 'uiState/payment/SET_PSDLAYER_TYPE';
export const SET_TO_TOUCHED = 'uiState/payment/SET_TO_TOUCHED';

export type SetSelectedPure = {
  value: string,
};

export type PsdLayerType = 'sca' | 'payment' | '';

export const setSelected = (value: TypeOfPayment | ''): PureAction => {
  return {
    type: PURE(SET_SELECTED),
    value,
  };
};

export const setInsuranceSelected = (value: TypeOfPayment | ''): PureAction => {
  return {
    type: PURE(SET_INSURANCE_SELECTED),
    value,
  };
};

export const setCcType = (value: string): PureAction => {
  return {
    type: PURE(SET_CC_TYPE),
    value,
  };
};

export const setCcTypeError = (value: boolean): PureAction => {
  return {
    type: PURE(SET_CC_TYPEERROR),
    value,
  };
};

export const setCcChallenge = (value: boolean): PureAction => {
  return {
    type: PURE(SET_CC_CHALLENGE),
    value,
  };
};

export const setCcIframeHeight = (value: number): PureAction => {
  return {
    type: PURE(SET_CC_IFRAMEHEIGHT),
    value,
  };
};

export const setFailedAuthAttempts = (): PureAction => {
  return {
    type: PURE(SET_FAILED_AUTH_ATTEMPTS),
  };
};

export const setPsdLayerType = (value: PsdLayerType): PureAction => {
  return {
    type: PURE(SET_PSDLAYER_TYPE),
    value,
  };
};

export const setToTouched = (): PureAction => {
  return {
    type: PURE(SET_TO_TOUCHED),
  };
};
